import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { FuzzerProfile } from '../models/FuzzerProfile';

export class FuzzerProfileMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): FuzzerProfile {
    const disabledRulesNumbers = data.disabledRules?.map((rule: any) => rule.ruleNumber);
    return new FuzzerProfile(this.gqlIdEncoder.decode(data.id), data.name, data.type, data.preset, new Set(disabledRulesNumbers));
  }
}
